import { TuiLoader } from '@taiga-ui/core';

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'pxc-spinner',
  templateUrl: './spinner.component.html',
  imports: [TuiLoader],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpinnerComponent {
  @Input() isVisible = true;
}
